import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import CampaignForm from './campaignForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCampaignById, getCampaignList } from '../../redux/selector';
import Notes from '../sharedChild/note/notes';
import Attachments from '../sharedChild/attachment/attachments';
import {
  fetchAttachmentsAndAppendToModule,
  fetchContactsAndAppendToModule,
  fetchDataAndUpdateStore,
  fetchDetailAndAppendToModule,
  fetchLeadsAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchTagsAndAppendToModule,
} from '../../redux/actions';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import ChildLead from '../sharedChild/childLead';
import Timeline from '../sharedChild/timeline';
import ChildDeal from '../sharedChild/childDeal';
import apiServices from '../../services/service';
import ChildContact from '../sharedChild/childContact';
import edit from '../../../src/assets/img/crm_home/header/edit.png';
import { toast } from 'react-toastify';
import { campaignInputData } from '../../shared/constants';
import { Tooltip } from 'react-tooltip';
import SelectionRemoveModal from '../../shared/component/SelectionRemoveModal';

const validationSchema = Yup.object().shape({});

const ViewCampaigns = ({}) => {
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    leads: useRef(null),
    opportunities: useRef(null),
    contacts: useRef(null),
    timeline: useRef(null),
  };
  const [activeTab, setActiveTab] = useState('overview');
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const campaignID = searchParams.get('id');
  const [opportunityByModule, setOpportunityByModule] = useState({});
  // const campaignLocalData = useSelector((state) => {
  //   const campaignId = location.state?.id || campaignID;
  //   return getCampaignById(state, campaignId);
  // });
  const [campaignLocalData, setCampaignLocalData] = useState(location.state || {});
  const campaignStoreData = useSelector((state) => {
    const campaignId = location.state?.id || campaignID; // Use the pre-fetched `leadID`
    return getCampaignById(state, campaignId);
  });

  const campaignList = useSelector(getCampaignList);
  const [refreshCampaignView, setRefreshCampaignView] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setCampaignLocalData((prev) => ({ ...prev, ...campaignStoreData }));
  }, [campaignStoreData]);

  let hasUpdateLeadPermission = true;
  let hasViewLeadPermission = true;
  let hasUpdateContactPermission = true;
  let hasViewContactPermission = true;
  let hasViewOpportunityPermission = true;
  let hasUpdateOpportunityPermission = true;
  let userUIControlPermissionLead = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.leadmenu;
  let userUIControlPermissionContact = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.contactmenu;
  let userUIControlPermissionOpportunity = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.opportunitymenu;

  if (userUIControlPermissionLead) {
    hasViewLeadPermission = userUIControlPermissionLead?.leadviewscreen
      ? userUIControlPermissionLead.leadviewscreen.canView
      : true;

    hasUpdateLeadPermission = userUIControlPermissionLead?.leadupdatescreen
      ? userUIControlPermissionLead.leadupdatescreen.canView
      : true;
  }
  if (userUIControlPermissionContact) {
    hasViewContactPermission = userUIControlPermissionContact?.contactviewscreen
      ? userUIControlPermissionContact.contactviewscreen.canView
      : true;

    hasUpdateContactPermission = userUIControlPermissionContact?.contactupdatescreen
      ? userUIControlPermissionContact.contactupdatescreen.canView
      : true;
  }
  if (userUIControlPermissionOpportunity) {
    hasViewOpportunityPermission = userUIControlPermissionOpportunity?.opportunityviewscreen
      ? userUIControlPermissionOpportunity.opportunityviewscreen.canView
      : true;

    hasUpdateOpportunityPermission = userUIControlPermissionOpportunity?.opportunityupdatescreen
      ? userUIControlPermissionOpportunity.opportunityupdatescreen.canView
      : true;
  }

  const handleClose = () => {
    setShow(false);
  };

  const handleConfirm = () => {
    stopORStartCampaign();
    setShow(false);
  };

  const handleOpenEditForm = (paramsValue) => {
    navigate('/campaigns/editCampaign', {
      state: formData,
    });
  };

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  const scrollContainerRef = useRef(null);

  const stopORStartCampaign = async () => {
    setLoading(true);
    const data = {
      id: formData?.id,
      brevoStatus: formData?.campaignStatus === 'InActive' ? 'queued' : 'suspended',
    };

    try {
      const response = await apiServices.stopORStartCampaign(data);

      if (response.status === 204) {
        await dispatch(
          fetchDataAndUpdateStore({
            key: 'campaignList',
            inputData: campaignInputData,
          })
        );
        setRefreshCampaignView((prev) => !prev);
        toast.success('Campaign Stopped Successfully!', {
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error while stopping campaign:', error);
    } finally {
      setLoading(false);
    }
  };

  const sendNow = async () => {
    setLoading(true);
    const data = {
      id: formData?.id,
    };

    try {
      const response = await apiServices.sendNow(data);

      if (response.status === 200) {
        await dispatch(
          fetchDataAndUpdateStore({
            key: 'campaignList',
            inputData: campaignInputData,
          })
        );
        setRefreshCampaignView((prev) => !prev);
        toast.success('Campaign Sent Successfully', {
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error while sending campaign:', error);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    setLoading(true);
    try {
      await dispatch(
        fetchDataAndUpdateStore({
          key: 'campaignList',
          inputData: campaignInputData,
        })
      );
      setRefreshCampaignView((prev) => !prev);
    } catch (error) {
      console.error('Error refreshing campaign list:', error);
      toast.error('Failed to refresh campaign list.', {
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const campaignId = location.state?.id || campaignID;
    if (location.pathname.includes('viewCampaign')) {
      // if (location.state) {
      //   const updatedFormData = {
      //     ...location.state,
      //     type: "view",
      //   };
      //   setFormData(updatedFormData);
      // } else {
      setFormData({
        ...campaignLocalData,
        type: 'view',
        from: 'view',
      });
      // }
    }
    if (campaignId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Campaign',
          id: campaignId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Campaign',
          id: campaignId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Campaign',
          id: campaignId,
        })
      );
      dispatch(
        fetchLeadsAndAppendToModule({
          moduleName: 'Campaign',
          id: campaignId,
        })
      );
      dispatch(
        fetchContactsAndAppendToModule({
          moduleName: 'Campaign',
          id: campaignId,
        })
      );
      // dispatch(
      //   fetchEmailAndAppendToModule({
      //     moduleName: "Campaign",
      //     id: campaignId,
      //   })
      // );
      dispatch(
        fetchTagsAndAppendToModule({
          moduleName: 'Campaign',
          id: campaignId,
        })
      );
    }
  }, [location, campaignLocalData?.id, refreshCampaignView]);

  useEffect(() => {
    setLoading(true);
    const data = { moduleName: 'Campaign', id: campaignLocalData?.id };
    apiServices
      .getOpportunityByModule(data)
      .then((response) => {
        if (response.status === 200) {
          const opportunityList = response.data;
          setOpportunityByModule(opportunityList);
          setLoading(false);
        } else {
          console.error('Error fetching user timelog settings:', response?.status);
        }
      })
      .catch((error) => {
        console.error('Error fetching user timelog settings:', error);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -30% 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 1,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="ViewLeadPageOuter">
      <div className="viewHeader">
        <HeaderProfileBlock localData={campaignLocalData} moduleName={'Campaign'} View={true} />
        <div className="rightAction" id="refreshSection">
          {loading ? (
            <div
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              title="Refreshing..."
            ></div>
          ) : (
            <div className="position-relative">
              <i
                className="bi bi-arrow-repeat"
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={refresh}
                data-tooltip-id="refresh-tooltip"
                data-tooltip-content="Refresh Campaign Status"
              ></i>

              {visible && (
                <div className="msgRefresh">
                  <div className="msgcard">
                    <p>
                      <span>Refresh Campaign Status</span>
                    </p>
                  </div>
                </div>
              )}
              <Tooltip id="refresh-tooltip" place="left" className="custom-react-tooltip" />
            </div>
          )}

          {new Date() < new Date(formData?.scheduledDateTime) && (
            // formData?.campaignStatus === "InActive" ? (
            //   <button
            //     className="btn btn-outline-primary ms-3"
            //     onClick={openModal}
            //     disabled={!formData}
            //   >
            //     <i className="bi bi-play-circle me-2"></i>
            //     <span className="btnText">Resume</span>
            //   </button>
            // ) : (
            <button
              className="btn btn-outline-primary ms-3"
              onClick={stopORStartCampaign}
              disabled={!formData || formData?.campaignStatus === 'InActive'}
            >
              <i className="bi bi-stop-circle me-2"></i>
              <span className="btnText">
                {formData?.campaignStatus === 'InActive' ? 'Stopped' : 'Stop'}
              </span>
            </button>
            // )
          )}
          <button
            className="btn btn-outline-primary ms-3"
            onClick={sendNow}
            disabled={
              !formData ||
              formData?.campaignStatus === 'Complete' ||
              formData?.campaignStatus === 'InActive'
            }
          >
            <i className="bi bi-send me-2"></i>
            <span className="btnText">Send Now</span>
          </button>

          <button
            className="btn btn-outline-primary ms-3"
            onClick={handleOpenEditForm}
            disabled={!formData}
          >
            <img src={edit} alt="Edit" className="me-2" style={{ width: '12px', height: '12px' }} />
            <span className="btnText">Edit</span>
          </button>
        </div>
      </div>
      {show && (
        <SelectionRemoveModal
          show={show}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
          text={
            <>
              You're about to send this campaign to the remaining contacts who didn't receive it
              before it was suspended. The campaign will be sent <strong>immediately</strong>.
            </>
          }
        />
      )}
      <div className="detailContainer">
        <div className="viewFormContainer">
          <div className="leftBlock">
            <ul>
              {Object.keys(refs).map((key) => (
                <li
                  key={key}
                  onClick={() => scrollToSection(key)}
                  style={{ cursor: 'pointer' }}
                  className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                >
                  <button onClick={() => setActiveTab(key)}>
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                    {['openActivities', 'closedActivities', 'invitedMeetings'].includes(key) && (
                      <span style={{ fontSize: '7px', fontWeight: '600' }}> (Coming Soon)</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="rightBlock" id="detailPageRight">
            <div className="addlead_container">
              <Formik
                initialValues={formData}
                // onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form>
                  <div className="tab-content">
                    <div id="overview" className="scrollTo" ref={refs.overview}></div>
                    <div className="addleadcard1">
                      {formData && (
                        <CampaignForm formData={formData} selectedOptions={selectedOptions} />
                      )}
                    </div>

                    <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                    <Attachments localData={campaignLocalData} module={'Campaign'} />
                    {hasViewLeadPermission && (
                      <>
                        <div id="leads" className="scrollTo" ref={refs.leads}></div>
                        <ChildLead
                          localData={campaignLocalData}
                          module={'Campaign'}
                          hasUpdateLeadPermission={hasUpdateLeadPermission}
                        />
                      </>
                    )}
                    {hasViewOpportunityPermission && (
                      <>
                        <div id="opportunities" className="scrollTo" ref={refs.opportunities}></div>
                        <ChildDeal
                          localData={opportunityByModule}
                          module={'Campaign'}
                          hasUpdateOpportunityPermission={hasUpdateOpportunityPermission}
                        />
                      </>
                    )}
                    {hasViewOpportunityPermission && (
                      <>
                        <div id="contacts" className="scrollTo" ref={refs.contacts}></div>
                        <ChildContact
                          localData={campaignLocalData}
                          module={'Campaign'}
                          id={campaignLocalData?.id}
                          hasUpdateContactPermission={hasUpdateContactPermission}
                        />
                      </>
                    )}
                    <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                    <Timeline localData={campaignLocalData} module={'Campaign'} />
                    <div>
                      <div>
                        <div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="timeline"></div>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
        <div className="viewFormNotesOuter">
          <div className="ViewFormNotesContainer">
            <Formik initialValues={formData} validationSchema={validationSchema}>
              <Form>
                <div id="notes" className="scrollTo" ref={refs.notes}></div>
                <Notes leadLocalData={campaignLocalData} module={'Campaign'} />
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCampaigns;
